export const actionTypes = {
  START_REQUEST: 'APP.CHECK_FACETS.START_REQUEST',
  REQUEST_SUCCESS: 'APP.CHECK_FACETS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.CHECK_FACETS.REQUEST_FAILURE',
};

export function startRequest(retryNumber) {
  return {
    type: actionTypes.START_REQUEST,
    payload: retryNumber,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
